import React, { createContext, useEffect, useState } from "react";
import { PropsType } from "../../interfaces/ChildrenType";
import { UserResponse } from "../../interfaces/UserData";
import { UserResultContextType } from "./user-types";

const UserData = sessionStorage.getItem("pepper-user-data");
const initialState: UserResultContextType = {
  userResult: JSON.parse(UserData as string) || undefined,

  setUserResult: () => { },
};

export const UserResultContext = createContext(initialState);

export const UserResultContextProvider: React.FC<PropsType> = ({
  children,
}) => {
  const [userResult, setUserResult] = useState<
    UserResponse | undefined
  >(initialState.userResult);

  useEffect(() => {
    if (userResult) {
      sessionStorage.setItem('pepper-user-data', JSON.stringify(userResult))
    } else {
      sessionStorage.removeItem("pepper-user-data");
    }
  }, [userResult])

  return (
    <UserResultContext.Provider
      value={{ userResult, setUserResult }}
    >
      {children}
    </UserResultContext.Provider>
  );
};
